import { authGet, getSavedUser, pubGet, pubJsonGet } from "functions/BaseAxios";
import { findTripDetailJQL } from "functions/JQL/ListingJQL";
import { credsJQL } from "functions/JQL/UserJQL";

export const FEATURED_HOME_TRIP = "FEATURED_HOME_TRIP";
export const PRIVATE_TRIP_AUTHOR = "PRIVATE_TRIP_AUTHOR";
export const RECENT_OPEN_TRIP = "RECENT_OPEN_TRIP";

export const getRecentOpenTrips = () => {
    return async (dispatch: DispatchGeneral) => {
        const user = await getSavedUser();
        let data;

        if (user) {
            data = await authGet(`auth/recent-open-trips-home`);
        } else {
            data = await pubGet(`recent-open-trips-home`);
        }
        dispatch({
            type: RECENT_OPEN_TRIP,
            payload: data.code === 200 ? data.payload.data : [],
        });
    };
}
export const getFeaturedTrip = (country: any, limit = 7, page = 1) => {
    return async (dispatch: DispatchGeneral) => {
        const user = await getSavedUser();
        let conditions = {
            where: {
                country_id: {
                    equalTo: country
                },
                product_isOpenTrip: {
                    equalTo: true
                },
                product_user: {
                    notEqualTo: '',
                }
            },
            pagination: {
                limit: limit,
                page: page,
            },
        };
        if (user) {
            conditions.where.product_user = {
                notEqualTo: user.user.id,
            };
        }

        var data = await pubJsonGet(findTripDetailJQL(conditions));
        dispatch({
            type: FEATURED_HOME_TRIP,
            payload: data.code === 200 ? { 'country': country, data: data.payload.product } : [],
        });
    };
}

export const getPrivateTripAuthor = (data: any) => {
    return async (dispatch: DispatchGeneral) => {
        var result = await pubJsonGet(credsJQL(data.user[0].id));
        dispatch({
            type: PRIVATE_TRIP_AUTHOR,
            payload: result.code === 200 ? { 'id': data.id, data: result.payload.user[0] } : [],
        });
    };
}

